import React from "react";
import { Link } from 'react-router-dom';
import Picture from './components/Picture.jsx';

const cards = [
  {
    key: "science",
    title: "Nascida da Ciência",
    desc:
      "Fundada em 2001 pelo físico quântico Drew Gill, a Gtechniq transforma ciência de superfícies em proteção real — pesquisa, testes rigorosos e aprimoramento contínuo que criam resultados de alto desempenho e durabilidade.",
    href: "/sobre",
    cta: "Sobre a Gtechniq",
    background: "/images/why/why-about.webp",
  },
  {
    key: "applicators",
    title: "Aplicadores Especializados",
    desc:
      "Rede credenciada com treinamento oficial e padrões rigorosos de aplicação. Acabamento impecável e máximo desempenho dos produtos Gtechniq.",
    href: "/encontre-um-profissional",
    cta: "Encontrar aplicador",
    secondaryHref: "/seja-um-aplicador-oficial",
    secondaryCta: "Torne-se um credenciado",
    background: "/images/why/why-accredited.webp",
  },
  {
    key: "crystal-serum",
    title: "Crystal Serum ULTRA",
    desc:
      "Revestimento cerâmico profissional em dupla camada (7H/10H): alta resistência a micro‑riscos e químicos, brilho intenso e forte repelência à água. O cerâmico mais avançado do mercado, protege por até 9 anos; aplicação exclusiva por credenciados.",
    href: "/produtos/crystal-serum-ultra",
    cta: "Conheça o Crystal Serum Ultra",
    background: "/images/why/why-ultra.webp",
  },
  {
    key: "system",
    title: "Proteção para Todas as Superfícies",
    desc:
      "Proteções para pintura, vidros, rodas, plásticos, tecidos, couro, vinil e PPF — para carros, embarcações, bicicletas e aeronaves. O produto certo para cada superfície.",
    href: "/produtos",
    cta: "Ver linha automotiva",
    background: "/images/why/why-system.webp",
  },
];

const WhySection = () => {
  const Card = ({ title, desc, href, cta, background, secondaryHref, secondaryCta }) => (
    <div className="relative group overflow-hidden border border-gray-700/40 shadow-xl transition-transform duration-500 hover:-translate-y-1">
      <Picture
        src={background}
        alt=""
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105 group-hover:blur-[5px]"
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 from-black bg-gradient-45 opacity-90 transition-all duration-500 group-hover:opacity-95"
        aria-hidden="true"
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/10"></div>
      <div className="relative z-10 flex h-full flex-col gap-4 p-6 text-white">
        <h3 className="text-3xl max-sm:text-[23px] font-bold  tracking-wide text-white">{title}</h3>

        <p className="text-[15px] max-sm:text-[14px] text-white">{desc}</p>

        <div className="mt-auto flex flex-wrap gap-3">
          <Link
            to={href}
            className="inline-flex min-w-[180px] items-center justify-center px-6 py-3 text-sm font-semibold uppercase tracking-wide text-white transition-all duration-300 bg-[#FF0000] hover:bg-white hover:text-[#FF0000]"
          >
            {cta}
          </Link>
          {secondaryHref && secondaryCta && (
            <Link
              to={secondaryHref}
              className="inline-flex min-w-[180px] items-center justify-center px-6 py-3 text-sm font-semibold uppercase tracking-wide text-white transition-all duration-300 border border-white/70 bg-white/10 hover:bg-white hover:text-[#FF0000]"
            >
              {secondaryCta}
            </Link>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <section className="relative z-20 -mt-[130px] max-sm:-mt-[90px] px-4 pb-0 pt-10">
      <div className="mx-auto w-full max-w-7xl">
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          {cards.map((card) => (
            <Card key={card.key} {...card} />
          ))}
        </div>
      </div>
      
    </section>
  );
};

export default WhySection;
